enum StatusEnum {
  completed = 1,
  inWork = 2,
  arrived = 3,
  received = 4,
  returned = 5,
  canceled = 6,
  draft = 7,
}

export default StatusEnum;